import createSpinner from "../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($uibModalInstance, helperService, FileSaver, usersDataService) {

    const vm = this;
    vm.cancel = cancel;
    vm.dismiss = dismiss;
    vm.disableButton = false;
    vm.exportUsersForBulkUpdate = exportUsersForBulkUpdate;
    vm.bulkUpdateUsers = bulkUpdateUsers;

    function cancel() { $uibModalInstance.close(); }
    function dismiss() { $uibModalInstance.dismiss(); }

    async function bulkUpdateUsers(file) {
        vm.importPending = new createSpinner;
        vm.disableButton = true;
        let fd = new FormData();
        fd.append(file[0].name, file[0].file);
        try {
            await usersDataService.bulkUpdateUsers(fd);
            await helperService.successfulSaveButton(vm.importPending);
            cancel();
        } catch {
            vm.importPending.loadingValue = false;
            vm.disableButton = false;
        }
    }

    async function exportUsersForBulkUpdate() {
        vm.downloadPending = new createSpinner();
        try {
            let response = await usersDataService.exportUsersForBulkUpdate();
            await helperService.successfulSaveButton(vm.downloadPending);
            FileSaver.saveAs(response.data, "BulkUpdateUsers.xlsx");
            vm.downloadPending.loadingValue = false;
        } catch {
            vm.downloadPending.loadingValue = false;
        }
    }
}